module.exports = __webpack_public_path__ + "img/fold.99f80d91.png";